<div class="maia-review-step" data-testid="maia-review-panel">
    <div class="step-canvas">
        <div class="step-stage">

            <section class="wizard-card" data-testid="maia-review-card">


                <h2 class="card-title">Review geocoding</h2>

                <div class="review-panel">

                    <div class="file-chip" data-testid="maia-review-file-chip">
                        <svg class="file-chip-check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <circle cx="12" cy="12" r="9" fill="currentColor"/>
                            <path d="m8.5 12.2 2.3 2.3 4.7-4.7" stroke="#ffffff" stroke-width="1.8"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="file-chip-text">{{ displayFileSummary }}</span>
                        <button type="button"
                                class="link-button"
                                data-testid="maia-replace-file-button"
                                (click)="replaceFileRequested.emit()">
                            Replace file
                        </button>
                    </div>

                    <!-- Sheets vary per workbook — always rendered from the response. -->
                    <div *ngIf="sheets.length" class="mapping-block" data-testid="maia-review-sheets">
                        <h3 class="mapping-title">Sheets detected</h3>
                        <p class="mapping-description">
                            {{ sheets.length }} sheets found<span *ngIf="skippedSheetCount">,
                            {{ skippedSheetCount }} skipped</span>.
                        </p>

                        <ul class="sheet-list">
                            <li *ngFor="let sheet of sheets"
                                class="sheet-row"
                                [class.sheet-row-skipped]="!sheet.included"
                                [attr.data-testid]="'maia-review-sheet-' + sheet.sheetName">
                                <span class="sheet-name">{{ sheet.sheetName }}</span>
                                <span class="sheet-meta">{{ sheetRowsLabel(sheet) }}</span>
                                <span *ngIf="sheet.currency" class="sheet-currency">{{ sheet.currency }}</span>
                                <span class="sheet-badge"
                                      [class.sheet-badge-skipped]="!sheet.included">
                                    {{ sheet.included ? 'Included' : 'Skipped' }}
                                </span>
                                <span *ngIf="sheet.skipReason" class="sheet-reason">{{ sheet.skipReason }}</span>
                            </li>
                        </ul>
                    </div>

                    <!-- <div class="mapping-block">
                        <h3 class="mapping-title">Map geocoding fields</h3>
                        <p class="mapping-description">
                            Select columns matching address fields. MAIA detected
                            {{ locationsRequiringGeocoding !== null ? locationsRequiringGeocoding : 0 }}
                            locations requiring geocoding.
                        </p>

                        <div class="mapping-grid">
                            <label class="mapping-field" *ngFor="let field of geocodingFields">
                                <span class="mapping-label">{{ field.label }}</span> -->
                                <!-- Phase 1: single static option, no column data source yet. -->
                                <!-- <select class="mapping-select"
                                        [attr.data-testid]="'maia-geocoding-field-' + field.testId">
                                    <option>{{ field.value }}</option>
                                </select>
                            </label>
                        </div>
                    </div> -->

                    <!-- Only when the parse actually flagged duplicates. They are flagged,
                         never removed, so this offers the fix round trip without blocking
                         Submit: the user may legitimately want to keep them. -->
                    <div *ngIf="hasDuplicates"
                         class="duplicate-block"
                         data-testid="maia-review-duplicates">
                        <div class="duplicate-head">
                            <svg class="duplicate-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <path d="M12 8.5v5M12 16.75v.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                <path d="M10.3 3.9 2.6 17.4a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"
                                      stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                            </svg>
                            <div class="duplicate-copy">
                                <h3 class="duplicate-title" data-testid="maia-review-duplicate-count">
                                    {{ duplicateRowCount }} duplicate
                                    {{ duplicateRowCount === 1 ? 'record' : 'records' }} found
                                </h3>
                                <p class="duplicate-description">
                                    These rows match another row in your file on every column except maptycs_location_id.
                                    Download the file to review them — duplicates are listed first — then upload it
                                    back once corrected. You can also continue without changing anything.
                                </p>
                            </div>
                        </div>

                        <div class="duplicate-actions">
                            <button type="button"
                                    class="link-button"
                                    data-testid="maia-review-duplicates-download-button"
                                    [disabled]="isDownloadingDuplicates"
                                    (click)="downloadDuplicates()">
                                {{ isDownloadingDuplicates ? 'Preparing download…' : 'Download duplicate records' }}
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 3v12m0 0-4.5-4.5M12 15l4.5-4.5M5 20h14"
                                          stroke="currentColor" stroke-width="1.8"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>

                            <input #duplicateFileInput
                                   type="file"
                                   class="duplicate-file-input"
                                   data-testid="maia-review-duplicates-file-input"
                                   [attr.accept]="acceptedExtensions"
                                   (change)="onDuplicateFileChange($event)"/>

                            <button type="button"
                                    class="link-button"
                                    data-testid="maia-review-duplicates-upload-button"
                                    [disabled]="isImportingDuplicates"
                                    (click)="openDuplicateFilePicker()">
                                {{ isImportingDuplicates ? 'Importing…' : 'Upload corrected file' }}
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 20V8m0 0-4.5 4.5M12 8l4.5 4.5M5 4h14"
                                          stroke="currentColor" stroke-width="1.8"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>

                        <p *ngIf="duplicateDownloadError"
                           class="duplicate-error"
                           data-testid="maia-review-duplicates-download-error">{{ duplicateDownloadError }}</p>

                        <p *ngIf="duplicateImportError"
                           class="duplicate-error"
                           data-testid="maia-review-duplicates-import-error">{{ duplicateImportError }}</p>
                    </div>

                    <!-- Outside the block above: an import that clears every duplicate hides
                         it, and the confirmation of that import has to survive. -->
                    <p *ngIf="duplicateImportMessage"
                       class="duplicate-success"
                       data-testid="maia-review-duplicates-import-success">{{ duplicateImportMessage }}</p>

                    <div class="info-strip info-strip-muted">
                        <svg class="strip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
                            <path d="M12 11v5.5M12 7.75v.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                        </svg>
                        <span class="strip-text">
                            Locations with existing latitude and longitude coordinates will not be geocoded.
                            Existing coordinates will be retained and used.
                        </span>
                    </div>

                </div>

                <div class="card-actions">
                    <button type="button"
                            class="secondary-button"
                            data-testid="maia-review-back-button"
                            (click)="back.emit()">
                        Back
                    </button>
                    <button type="button"
                            class="primary-button"
                            data-testid="maia-review-submit-button"
                            (click)="submitForGeocoding()">
                        Submit
                    </button>
                </div>

            </section>

        </div>
    </div>
</div>
